export const ROLES = {
  ADMIN: "ROLE_ADMIN",
  SUBADMIN: "ROLE_SUBADMIN",
  USER: "ROLE_USER",
  CHAIN: "ROLE_CHAIN",
  STORE: "ROLE_STORE",
};

export const ROLES_MAPPING_ROUTER = {
  ROLE_ADMIN: "admin",
  ROLE_SUBADMIN: "sub_admin",
  ROLE_USER: "user",
  ROLE_CHAIN: "chain",
  ROLE_STORE: "store",
};

export const ACCESS_TOKEN_KEY = "accesstoken";

export const ERROR_STATUS = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  NOT_AUTHENTICATION: 401,
  Forbidden: 403,
  NotFound: 404,
  GeneralServerRrror: 500,
  Unavailable: 503,
};

export const ERROR_MESSAGES = {
  ERROR_LOGIN_POST_USERINACTIVE: "ERROR-LOGIN-POST-USERINACTIVE",
};

export const DATE_FORMAT = "YYYY/MM/DD";
export const ISO_DATE_FORMAT = "YYYY-MM-DD";
export const GANTT_CHART_DATE_FORMAT = "YYYY-MM-DD";
export const TIME_JAPAN_FORMAT = "YYYY年MM月DD日, HH:mm:ss";
export const IMAGE_FILE_TYPE_PRE = "image/";
export const IMAGE_FILE_TYPE_ACCEPT = ["image/jpeg", "image/png"];
export const MAX_TOTAL_FILE_SIZE_IMAGE = 52428800; // 50Mb
export const TASK_IMAGE_DEFAULT_WIDTH = "300";
export const MAX_TOTAL_FILE_SIZE = 50 * (1024 * 1024);
export const MAX_MANUAL_FILE_SIZE = 100000000; // 100Mb
export const TYPE_ATTACH_FILE = {
  TASK: 1,
  COMMENT_TASK : 2,
  FILE_NOTE: 3,
};

export const TASK_MODE = {
  CREATE: "TASK_CREATE",
  EDIT: "TASK_EDIT",
  CLONE: "TASK_CLONE",
};

export const COMMENT_VIEW_MODE = {
  COMMENT: "comment",
  HISTORY: "history",
};

export const COMMENT_SORT_BY = {
  CREATED_DATE: "created_date",
  UPDATED_DATE: "updated_date",
};

export const TIMEZONE_JAPAN = "Asia/Tokyo";
export const DATE_TIME_FORMAT = "YYYY/MM/DD HH:mm:ss";
export const DATE_AND_HOUR_MINUTES_FORMAT = "YYYY/MM/DD HH:mm";
export const TIME_FORMAT = "HH:mm:ss";
export const HOUR_MINUTES_FORMAT = "HH:mm";
export const MONTH_FORMAT = "YYYY/MM";

export const NOTIFY = {
  CHANGE_OTA: "下記サイトのパスワードが更新されました",
  NEW_COMMENT: "新しいコメントが届きました",
  CHANE_STATUS: "ステータスが変更されました",
};

export const KEYS = {
  TODAY: "TODAY",
  YESTERDAY: "YESTERDAY",
  MORE: "MORE",
};

export const OTA_STATUS = {
  ENABLED: "ENABLED",
  DISABLED: "DISABLED",
};

export const API_PLAN_OTA_STATUS = {
  0: "失敗",
  1: "成功",
};

export const ONE_DAY_MILISECOND = 1000 * 60 * 60 * 24;

export const X_REQUESTED_STOREID = "X-Requested-StoreId";
export const X_REQUESTED_CHAINID = "X-Requested-ChainId";

export const OTA_FIELD_NAME = "ITEMID10010";
export const AVAILABLE_FIELD_NAME = "ITEMID10014";
export const POST_TIME_FIELD_NAME = "ITEMID10015";
export const TARGET_PLAN_FIELD_NAME = "ITEMID10079";

export const PLANID_VISIBLE_TARGET_PLAN = [10001, 10002];

export const ITEM_CATEGORY_PLAN_IGNORE = [10030];

export const otaValues = {
  じゃらん: "JARAN_TAB",
  楽天: "RAKUTEN_TAB",
  るるぶ: "RURUBU_TAB",
  予約プロ: "YOYAKU_PRO_TAB",
  一休: "IKKYU_TAB",
  ダイレクトイン: "DAIREKUTOIN_TAB",
};

export const otaNames = [
  "JARAN_TAB",
  "RAKUTEN_TAB",
  "RURUBU_TAB",
  "YOYAKU_PRO_TAB",
  "IKKYU_TAB",
  "DAIREKUTOIN_TAB",
];

export const ignoreChangedKeys = [
    'attachs',
    'assigneeId',
    'childs',
    'commentType',
    'comments',
    'deliveryDate',
    'startDate',
    'dueDate',
    'estTime',
    'estPoint',
    'status',
    'taskId',
    'directorId',
    'actualTime',
    'registerPersonId',
    'registerDate',
    'storeId',
    'parentTaskId',
    'visible',
    'planId',
    'assignedMember',
    'doingUser',
    'doneUser',
    'storeName',
    'oldTask',
    'items',
    'basic',
    'detail',
    'selectedCategoryTree',
    'tabValue',
];

export const changedKeys = {
    categoryId: "page.taskAddEdit.category",
    title: "page.taskAddEdit.title",
    note: "page.taskAddEdit.remarks",
    priority: "page.taskAddEdit.priority",
    show: "page.taskAddEdit.isVisible",
    executedTeam: "page.taskAddEdit.executedTeam",
    workSheet: "page.taskAddEdit.workSheet",
    fixedDeadline: "page.taskAddEdit.fixedDeadline",
    storeIds: "page.taskAddEdit.store",
    titlePrice: "page.TemPlate.titlePriceDefault",
    priceChildren: "page.TemPlate.titlePriceChildren",
    cancellationPolicy: "page.TemPlate.cancellationPolicy",
    subCategoryId: "page.taskAddEdit.subCategory",
    taskContent: "page.taskList.taskContent",
    supplement: "page.taskAddEdit.supplement",
    executeAssigneeIds: "page.taskAddEdit.workConfirmSettings.executeAssignee",
    confirmAssigneeIds: "page.taskAddEdit.workConfirmSettings.confirmAssignee",
    executeClassification: "page.taskAddEdit.workConfirmSettings.classification",
    confirmClassification: "page.taskAddEdit.workConfirmSettings.classification",
    executeAdjustStatus: "page.taskAddEdit.workConfirmSettings.adjustStatus",
    confirmAdjustStatus: "page.taskAddEdit.workConfirmSettings.adjustStatus",
    executeDueDate: "page.taskAddEdit.workConfirmSettings.executeDueDate",
    confirmDueDate: "page.taskAddEdit.workConfirmSettings.confirmDueDate",
    executeMemo: "page.taskAddEdit.workConfirmSettings.executeMemo",
    confirmMemo: "page.taskAddEdit.workConfirmSettings.confirmMemo",
    ITEMID10010: "page.taskAddEdit.otaItem.targetOTA",
    ITEMID10011: "page.taskAddEdit.basicPlanInfo.title.roomUse",
    ITEMID10012: "page.taskAddEdit.basicPlanInfo.title.planTitle",
    ITEMID10013: "page.taskAddEdit.explanatoryText.title.planContent",
    ITEMID10014: "page.taskAddEdit.basicPlanInfo.title.availableTime",
    ITEMID10015: "page.taskAddEdit.basicPlanInfo.title.postTime",
    ITEMID10016: "page.taskAddEdit.basicPlanInfo.title.endTime",
    ITEMID10017: "page.taskAddEdit.basicPlanInfo.title.checkIn",
    ITEMID10018: "page.taskAddEdit.basicPlanInfo.title.checkOut",
    ITEMID10019: "page.taskAddEdit.basicPlanInfo.title.minConsecutiveNight",
    ITEMID10020: "page.taskAddEdit.basicPlanInfo.title.maxConsecutiveNight",
    ITEMID10021: "page.taskAddEdit.basicPlanInfo.title.mealCondition",
    ITEMID10022: "page.taskAddEdit.basicPlanInfo.title.paymentMethod",
    ITEMID10023: "page.taskAddEdit.explanatoryText.title.questionsToBooker",
    ITEMID10024: "page.taskAddEdit.explanatoryText.title.chargeSpecialNote",
    ITEMID10025: "page.taskAddEdit.basicPlanInfo.title.reservationStartDate",
    ITEMID10027: "page.taskAddEdit.basicPlanInfo.title.rewardPoints",
    ITEMID10029: "page.taskAddEdit.explanatoryText.title.childFeeSpecialNote",
    ITEMID10030: "page.taskAddEdit.photoGalleryModification.taskDetail.title",
    ITEMID10031: "page.taskAddEdit.cost.patternDefault.title",
    ITEMID10032: "page.taskAddEdit.basicPlanInfo.title.bathTax",
    ITEMID10033: "page.taskAddEdit.explanatoryText.title.packagePlanContent",
    ITEMID10034: "page.taskAddEdit.basicPlanInfo.title.planRank",
    ITEMID10035: "page.taskAddEdit.jaran.package.title",
    ITEMID10036: "page.taskAddEdit.jaran.informationServices.title",
    ITEMID10037: "page.taskAddEdit.jaran.lodgingLogPost.title",
    ITEMID10038: "page.taskAddEdit.rakuten.salesDestination.title",
    ITEMID10039: "page.taskAddEdit.rakuten.inboundSales.title",
    ITEMID10040: "page.taskAddEdit.rakuten.planFeatures.title",
    ITEMID10041: "page.taskAddEdit.rakuten.rakutenSuperPoint.title",
    ITEMID10042: "page.taskAddEdit.rakuten.limitedSales.title",
    ITEMID10043: "page.taskAddEdit.rurubu.limitMenWomen.title",
    ITEMID10044: "page.taskAddEdit.youaku.planForm.title",
    ITEMID10045: "page.taskAddEdit.youaku.planIntroduction1.title",
    ITEMID10046: "page.taskAddEdit.youaku.planIntroduction2.title",
    ITEMID10047: "page.taskAddEdit.youaku.mealIntroduction.title",
    ITEMID10048: "page.taskAddEdit.youaku.installationFee.title",
    ITEMID10049: "page.taskAddEdit.ikkyu.designateSalesDestination.title",
    ITEMID10050: "page.taskAddEdit.ikkyu.planCode.title",
    ITEMID10051: "page.taskAddEdit.dairekutoin.rangeOfCharges.title",
    ITEMID10052: "page.taskAddEdit.roomCreationInstructions.roomTypeName.title",
    ITEMID10053: "page.taskAddEdit.roomCreationInstructions.amountPeople.title",
    ITEMID10054: "page.taskAddEdit.roomCreationInstructions.roomTypeExplanation.title",
    ITEMID10055: "page.taskAddEdit.roomCreationInstructions.roomSize.title",
    ITEMID10056: "page.taskAddEdit.roomCreationInstructions.roomType.title",
    ITEMID10057: "page.taskAddEdit.roomCreationInstructions.roomEquipment.title",
    ITEMID10058: "page.taskAddEdit.roomCreationInstructions.bedInformation.title",
    ITEMID10059: "page.taskAddEdit.rakuten.roomChargeFormat.title",
    ITEMID10060: "page.taskAddEdit.rakuten.publicFlag.title",
    ITEMID10061: "page.taskAddEdit.rakuten.id.title",
    ITEMID10062: "page.taskAddEdit.rakuten.paymentMethod.title",
    ITEMID10063: "page.taskAddEdit.jaran.grade.title",
    ITEMID10064: "page.taskAddEdit.jaran.view.title",
    ITEMID10065: "page.taskAddEdit.jaran.bedding.title",
    ITEMID10066: "page.taskAddEdit.jaran.acceptanceConditions.title",
    ITEMID10067: "page.taskAddEdit.basicRoomProvided.title",
    ITEMID10068: "page.taskAddEdit.rurubu.guestRoomUsage.title",
    ITEMID10069: "page.taskAddEdit.ikkyu.sleepingWithChildren.title",
    ITEMID10070: "page.taskAddEdit.ikkyu.romCode.title",
    ITEMID10071: "page.taskAddEdit.other.image.title",
    ITEMID10072: "page.taskAddEdit.photoGalleryModification.caption.title",
    ITEMID10073: "page.taskAddEdit.photoGalleryModification.displaySettingAndArrangement.title",
    ITEMID10074: "page.taskAddEdit.other.targetPeriod.title",
    ITEMID10075: "page.taskAddEdit.photoGalleryModification.imageDataStoreUrl.title",
    ITEMID10076: "page.taskAddEdit.other.editingRange.title",
    ITEMID10077: "page.taskAddEdit.other.targetArea.title",
    ITEMID10078: "page.taskAddEdit.other.date.title",
    ITEMID10079: "page.taskAddEdit.other.targetPlan.title",
    ITEMID10080: "page.taskAddEdit.roomCreationInstructions.amountPeople.title",
    ITEMID10081: "page.taskAddEdit.other.referencePage.title",
    ITEMID10082: "page.taskAddEdit.basicPlanInfo.title.ReservablePeriod",
    referencePlanOta: "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.referencePlanOta",
    targetOta: "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.targetOta",
    roomTypeToLink: "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.roomTypeToLink",
    postPeriod: "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.postPeriod",
    "postPeriod.from": "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.postPeriod",
    "postPeriod.to": "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.postPeriod",
    salePeriod: "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.salePeriod",
    "salePeriod.from": "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.salePeriod",
    "salePeriod.to": "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.salePeriod",
    pricingSetting: "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.pricingSetting",
    extraImage: "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.extraImage",
    caption: "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.caption",
    dpSetting: "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.dpSetting",
    otherSetting: "page.taskAddEdit.extraField.parentCategory10000.subCategory10000.otherSetting",
    type: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.type",
    targetOtaExtension: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.targetOtaExtension",
    postPeriodExtension: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.postPeriodExtension",
    "postPeriodExtension.from": "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.postPeriodExtension",
    "postPeriodExtension.to": "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.postPeriodExtension",
    stayPeriodExtension: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.stayPeriodExtension",
    "stayPeriodExtension.from": "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.stayPeriodExtension",
    "stayPeriodExtension.to": "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.stayPeriodExtension",
    planNameAndPlanIdExtension: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.planNameAndPlanIdExtension",
    entryExtension: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.entryExtension",
    surveyResponseExtension: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.surveyResponseExtension",
    imageExtension: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.imageExtension",
    referencePlanOtaPlanCreating: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.referencePlanOtaPlanCreating",
    targetOtaPlanCreating: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.targetOtaPlanCreating",
    roomTypeToLinkPlanCreating: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.roomTypeToLinkPlanCreating",
    postPeriodPlanCreating: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.postPeriodPlanCreating",
    "postPeriodPlanCreating.from": "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.postPeriodPlanCreating",
    "postPeriodPlanCreating.to": "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.postPeriodPlanCreating",
    salePeriodPlanCreating: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.salePeriodPlanCreating",
    "salePeriodPlanCreating.from": "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.salePeriodPlanCreating",
    "salePeriodPlanCreating.to": "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.salePeriodPlanCreating",
    pricingSettingPlanCreating: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.pricingSettingPlanCreating",
    imagePlanCreating: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.imagePlanCreating",
    captionPlanCreating: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.captionPlanCreating",
    dpSettingPlanCreating: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.dpSettingPlanCreating",
    entryPlanCreating: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.entryPlanCreating",
    surveyResponsePlanCreating: "page.taskAddEdit.extraField.parentCategory10000.subCategory10002.surveyResponsePlanCreating",
    targetPlan: "page.taskAddEdit.extraField.parentCategory10001.targetPlan",
    detailChange: "page.taskAddEdit.extraField.parentCategory10001.detailChange",
    importantPoint: "page.taskAddEdit.extraField.parentCategory10001.importantPoint",
    targetRoom: "page.taskAddEdit.extraField.parentCategory10330.targetRoom",
    otherInformation: "page.taskAddEdit.extraField.parentCategory10330.otherInformation",
    promotionName: "page.taskAddEdit.extraField.parentCategory10331.promotionName",
    stayPeriod: "page.taskAddEdit.extraField.parentCategory10331.stayPeriod",
    "stayPeriod.from": "page.taskAddEdit.extraField.parentCategory10331.stayPeriod",
    "stayPeriod.to": "page.taskAddEdit.extraField.parentCategory10331.stayPeriod",
    reservationPeriod: "page.taskAddEdit.extraField.parentCategory10331.reservationPeriod",
    "reservationPeriod.from": "page.taskAddEdit.extraField.parentCategory10331.reservationPeriod",
    "reservationPeriod.to": "page.taskAddEdit.extraField.parentCategory10331.reservationPeriod",
    discountRate: "page.taskAddEdit.extraField.parentCategory10331.discountRate",
    linkedRoom: "page.taskAddEdit.extraField.parentCategory10331.linkedRoom",
    linkedPlan: "page.taskAddEdit.extraField.parentCategory10331.linkedPlan",
    notePromotion: "page.taskAddEdit.extraField.parentCategory10331.notePromotion",
    extendedPostingPeriod: "page.taskAddEdit.extraField.parentCategory10332.extendedPostingPeriod",
    "extendedPostingPeriod.from": "page.taskAddEdit.extraField.parentCategory10332.extendedPostingPeriod",
    "extendedPostingPeriod.to": "page.taskAddEdit.extraField.parentCategory10332.extendedPostingPeriod",
    extendedSalesPeriod: "page.taskAddEdit.extraField.parentCategory10332.extendedSalesPeriod",
    "extendedSalesPeriod.from": "page.taskAddEdit.extraField.parentCategory10332.extendedSalesPeriod",
    "extendedSalesPeriod.to": "page.taskAddEdit.extraField.parentCategory10332.extendedSalesPeriod",
    targetFeeG: "page.taskAddEdit.extraField.parentCategory10002.subCategory10004.targetFeeG",
    referenceFeeG: "page.taskAddEdit.extraField.parentCategory10002.subCategory10004.referenceFeeG",
    referenceRoom: "page.taskAddEdit.extraField.parentCategory10003.subCategory10005.referenceRoom",
    roomName: "page.taskAddEdit.extraField.parentCategory10003.subCategory10005.roomName",
    numberOfPeopleAccepted: "page.taskAddEdit.extraField.parentCategory10003.subCategory10005.numberOfPeopleAccepted",
    OTAToCreate: "page.taskAddEdit.extraField.parentCategory10005.OTAToCreate",
    targetPlanRoom: "page.taskAddEdit.extraField.parentCategory10005.targetPlanRoom",
    targetLocation: "page.taskAddEdit.extraField.parentCategory10005.targetLocation",
    detailRequest: "page.taskAddEdit.extraField.parentCategory10005.detailRequest",
    targetPlanLinking: "page.taskAddEdit.extraField.parentCategory10002.subCategory10003.targetPlanLinking",
    other: "page.taskAddEdit.extraField.parentCategory10332.other",
    taskFormat: "page.taskAddEdit.taskFormat",
    ITEM1: "page.taskAddEdit.basicPlanInfo.title.roomUse",
    ITEM2: "page.taskAddEdit.basicPlanInfo.title.planTitle",
    ITEM3: "page.taskAddEdit.explanatoryText.title.planContent",
    ITEM4: "page.taskAddEdit.basicPlanInfo.title.availableTime",
    ITEM5: "page.taskAddEdit.basicPlanInfo.title.postTime",
    ITEM6: "page.taskAddEdit.basicPlanInfo.title.endTime",
    ITEM7: "page.taskAddEdit.basicPlanInfo.title.checkIn",
    ITEM8: "page.taskAddEdit.basicPlanInfo.title.checkOut",
    ITEM9: "page.taskAddEdit.basicPlanInfo.title.minConsecutiveNight",
    ITEM10: "page.taskAddEdit.basicPlanInfo.title.maxConsecutiveNight",
    ITEM11: "page.taskAddEdit.basicPlanInfo.title.mealCondition",
    ITEM12: "page.taskAddEdit.basicPlanInfo.title.paymentMethod",
    ITEM13: "page.taskAddEdit.explanatoryText.title.questionsToBooker",
    ITEM14: "page.taskAddEdit.explanatoryText.title.chargeSpecialNote",
    ITEM15: "page.taskAddEdit.basicPlanInfo.title.reservationStartDate",
    ITEM17: "page.taskAddEdit.basicPlanInfo.title.rewardPoints",
    ITEM19: "page.taskAddEdit.explanatoryText.title.childFeeSpecialNote",
    ITEM20: "page.taskAddEdit.photoGalleryModification.taskDetail.title",
    ITEM21: "page.taskAddEdit.cost.patternDefault.title",
    ITEM22: "page.taskAddEdit.basicPlanInfo.title.bathTax",
    ITEM23: "page.taskAddEdit.explanatoryText.title.packagePlanContent",
    ITEM24: "page.taskAddEdit.basicPlanInfo.title.planRank",
    ITEM25: "page.taskAddEdit.jaran.package.title",
    ITEM26: "page.taskAddEdit.jaran.informationServices.title",
    ITEM27: "page.taskAddEdit.jaran.lodgingLogPost.title",
    ITEM28: "page.taskAddEdit.rakuten.salesDestination.title",
    ITEM29: "page.taskAddEdit.rakuten.inboundSales.title",
    ITEM30: "page.taskAddEdit.rakuten.planFeatures.title",
    ITEM31: "page.taskAddEdit.rakuten.rakutenSuperPoint.title",
    ITEM32: "page.taskAddEdit.rakuten.limitedSales.title",
    ITEM33: "page.taskAddEdit.rurubu.limitMenWomen.title",
    ITEM34: "page.taskAddEdit.youaku.planForm.title",
    ITEM35: "page.taskAddEdit.youaku.planIntroduction1.title",
    ITEM36: "page.taskAddEdit.youaku.planIntroduction2.title",
    ITEM37: "page.taskAddEdit.youaku.mealIntroduction.title",
    ITEM38: "page.taskAddEdit.youaku.installationFee.title",
    ITEM39: "page.taskAddEdit.ikkyu.designateSalesDestination.title",
    ITEM40: "page.taskAddEdit.ikkyu.planCode.title",
    ITEM41: "page.taskAddEdit.dairekutoin.rangeOfCharges.title",
    ITEM42: "page.taskAddEdit.roomCreationInstructions.roomTypeName.title",
    ITEM43: "page.taskAddEdit.roomCreationInstructions.amountPeople.title",
    ITEM44: "page.taskAddEdit.roomCreationInstructions.roomTypeExplanation.title",
    ITEM45: "page.taskAddEdit.roomCreationInstructions.roomSize.title",
    ITEM46: "page.taskAddEdit.roomCreationInstructions.roomType.title",
    ITEM47: "page.taskAddEdit.roomCreationInstructions.roomEquipment.title",
    ITEM48: "page.taskAddEdit.roomCreationInstructions.bedInformation.title",
    ITEM49: "page.taskAddEdit.rakuten.roomChargeFormat.title",
    ITEM50: "page.taskAddEdit.rakuten.publicFlag.title",
    ITEM51: "page.taskAddEdit.rakuten.id.title",
    ITEM52: "page.taskAddEdit.rakuten.paymentMethod.title",
    ITEM53: "page.taskAddEdit.jaran.grade.title",
    ITEM54: "page.taskAddEdit.jaran.view.title",
    ITEM55: "page.taskAddEdit.jaran.bedding.title",
    ITEM56: "page.taskAddEdit.jaran.acceptanceConditions.title",
    ITEM57: "page.taskAddEdit.basicRoomProvided.title",
    ITEM58: "page.taskAddEdit.rurubu.guestRoomUsage.title",
    ITEM59: "page.taskAddEdit.ikkyu.sleepingWithChildren.title",
    ITEM60: "page.taskAddEdit.ikkyu.romCode.title",
    ITEM61: "page.taskAddEdit.other.image.title",
    ITEM62: "page.taskAddEdit.photoGalleryModification.caption.title",
    ITEM63: "page.taskAddEdit.photoGalleryModification.displaySettingAndArrangement.title",
    ITEM64: "page.taskAddEdit.other.targetPeriod.title",
    ITEM65: "page.taskAddEdit.photoGalleryModification.imageDataStoreUrl.title",
    ITEM66: "page.taskAddEdit.other.editingRange.title",
    ITEM67: "page.taskAddEdit.other.targetArea.title",
    ITEM68: "page.taskAddEdit.other.date.title",
    ITEM70: "page.taskAddEdit.roomCreationInstructions.amountPeople.title",
    ITEM71: "page.taskAddEdit.other.referencePage.title",
    ITEM72: "page.taskAddEdit.basicPlanInfo.title.ReservablePeriod",
}

export const TYPE_ACTIVE_COPY_TASK = {
  ENABLED : true,
  STOPPED : false
}

export const TYPE_ACTIVE_TEAM = {
  ACTIVE: true,
  INACTIVE: false
}

export const TEAM_ERROR_KEY = [
    "SELECT_PARENT_TEAM_DELETED_OR_INACTIVE_ERROR_MESS",
    "DELETE_PARENT_TEAM_ERROR_MESS",
]

export const TYPE_WEEKEND = {
  MOVE_BACK : '-',
  MOVE_FORWARD : '+'
}

export const TYPE_MONTH = {
  EVERY : '1',
  SPECIFIED : '2'
}

export const searchSelect = {
  showSearch: true,
  optionFilterProp: "children",
};

export const searchSelectLabel = {
  showSearch: true,
  optionFilterProp: "label",
};

export const MODE_SCREEN = {
  NEW : 'new',
  EDIT : 'edit',
  COPY : 'clone',
}

export const TYPE_SORT = {
    asc: '0',
    desc: '1',
};

export const TASK_FORMAT = {
    ORIGIN : '清書',
    DRAFT : '下書き'
}

export const LIST_TEAM_USE_DRAFT_TASK = [
    'Director',
    'AD',
    'CR',
    'PS',
    'RS'
];

export const MODE_ON_HAND = 1;
export const MODE_DOR = 2;
export const MODE_ROOM_OCCUPANCY_RATE = 3;
export const MODE_LEAD_TIME = 4;

export const IS_MAINTENANCE_MODE = false;

export const IGNORE_TITLE_MIDDLE_SELECT_IDS = {
    PLAN_FEE: 10013,
    PLAN_DAILY_STOP_RELEASE: 10017,
    ROOM_INFO_EDIT: 10024,
    PROMOTION_COUPON_FEATURE_PROMOTION: 10046,
};